import { ref } from 'vue';

const getExternalTimesMissing = () => {
    const externalTimeMissing_error = ref(null);
    const externalTimesMissing = ref(null);

    const loadExternalTimesMissing = async ( monitor_others, view_locations) => {
        var params = [];
        params.push(['monitor_others',monitor_others]);
        params.push(['view_locations', view_locations]);
        params.push(['type','missing'])
       // console.log("api getExternalTimesMissing: " , params);

        try {
            //console.log("api getExternalTimesMissing: " , new URLSearchParams(params));
            let data = await fetch("/api/externaltimes?" + new URLSearchParams(params));

            //console.log("data oimapp: " ,data);
            if (!data.ok) {
                throw Error("Can't load data");
            }

            externalTimesMissing.value = await data.json();
            //console.log(externalTimesMissing);
        } catch (err) {
            externalTimeMissing_error.value = err.message;
        }
    };

    const setExternalOuttime = async (externaltime) => {
        const tokenResponse = await fetch( '/sanctum/csrf-cookie', {
            method: 'GET',
            credentials: 'include'
        });
        const token = decodeURIComponent(getCookie('XSRF-TOKEN'));

        try {
            const response = await fetch('/api/getemployeedayformissingexternaltime?id=' + externaltime.id + '&employee_id=' + externaltime.employee_id);
            if (!response.ok) {
                console.log(response.body);
            }
            var employeeDay = await response.text();
            employeeDay = JSON.parse(employeeDay);

            Date.prototype.toJSON = function(){
                const hoursDiff = this.getHours() - this.getTimezoneOffset() / 60;
                this.setHours(hoursDiff);
                return this.toISOString();
            };
            externaltime.in_at = employeeDay.start_at;
            externaltime.out_at = employeeDay.end_at;

            const requestOptionsExternalTime = {
                method: 'POST',
                headers: {
                    'X-XSRF-TOKEN': token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(externaltime)
            };

            try {
                const responseExternalTime = await fetch('/api/externaltimes', requestOptionsExternalTime);
                if (!responseExternalTime.ok) {
                    console.log(responseExternalTime.body);
                }
            } catch (err) {
                externalTimeMissing_error.value = err.message;
                console.log(err.message);
            }
        } catch (err) {
            externalTimeMissing_error.value = err.message;
            console.log(err.message);
        }
    };

    return { externalTimesMissing, externalTimeMissing_error, loadExternalTimesMissing, setExternalOuttime };
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export default getExternalTimesMissing;
